import React, { Children, useEffect, useState } from "react";
import { Flex, Card, Input, Divider, Tabs } from "antd";
import getCurrentShop from '../shop/get-current-shop';
import MyPartnerList from "../shop/my-partner-list";
import MyShareList from "./my-share-list";


export default () => {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab') || 'proxy';

    const shopTabs = [
        {
            key: "proxy",
            label: "我的代理商",
            children: <div>
                <MyPartnerList />
            </div>
        },
        {
            key: "share",
            label: "我的分销商",
            children: <div>
                <MyShareList />
            </div>
        }
    ];

    return (
        <div>
            {/* <Divider /> */}
            <Tabs defaultActiveKey={tab} items={shopTabs} />
            
        </div>
    );
};
